<template>
    <div class="box">
        <div class="header">
            <Row v-if="hasPermission('addTemplate')" type="flex" class="toolbar">
                <Col span="24">
                <Button
                        ref="upload_btn"
                        @click="$router.push('detail/0')"
                        icon="md-add"
                        type="primary"
                >{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.button.add') }}</Button>
                </Col>
            </Row>
            <div class="filter">
                <ul class="filter-box">
                    <li>
                        <span>{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.filter.templateNameLike') }}</span>
                        <Input
                                v-model="filter.templateNameLike"
                                class="selector"
                                size="small"
                                clearable
                                :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <li v-if="dep">
                        <span>{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.filter.userCode') }}</span>
                        <Input
                                v-model="filter.userCode"
                                class="selector"
                                size="small"
                                clearable
                                :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                </ul>
            </div>
        </div>
        <div ref="list" class="content">
            <ul class="list">
                <li
                        :key="p.id"
                        v-for="p in list"
                        class="item"
                >
                    <div class="item-thumb">
                        <PrettyImage :src="p.httpUrl + p.backgroundPath"/>
                    </div>

                    <div class="item-info">
                        <span class="title">
                            <span class="titleLink" :title="p.templateName">
                                {{p.templateName}}
                            </span>
                        </span>
                        <ul class="list">
                            <li>
                                <span class="title">{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.list.id') }}</span>
                                <span class="content">{{ p.id }}</span>
                            </li>
                            <li>
                                <span class="title">{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.list.userName') }}</span>
                                <span class="content">{{ p.userName }}</span>
                            </li>
                            <li>
                                <span class="title">{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.list.templateDimension') }}</span>
                                <span class="content">{{ p.templateDimension }}</span>
                            </li>
                            <li>
                                <span class="title" >{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.list.createDatetime') }}</span>
                                <span class="content">{{ p.createDatetime }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="item-op">
                        <Button
                                v-if="hasPermission('editTemplate')"
                                class="edit_btn"
                                type="dashed"
                                size="large"
                                icon="md-settings"
                                @click="e=>e.stopPropagation()"
                                :to="'detail/'+ p.id"
                        >{{ $t('Button.edit') }}</Button>
                        <Button
                                v-if="hasPermission('virtualTemplate')"
                                class="edit_btn"
                                type="dashed"
                                size="large"
                                icon="md-settings"
                                @click="$router.push(`management/${p.id}/${p.userId}`)"
                        >{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.button.management') }}</Button>
                        <Button
                                v-if="hasPermission('copyTemplate')"
                                class="edit_btn"
                                type="dashed"
                                size="large"
                                icon="md-create"
                                @click="addCopySettings(p.id, p.templateName)"
                        >{{ $t('Button.copy.common') }}</Button>
                        <Modal
                                v-model="copy_dialog"
                                :title="$t('virtualOfficeManagement.virtualOfficeTemplate.List.copyDialog.title')"
                        >
                            <Form :label-width="100">
                                <FormItem :label="$t('virtualOfficeManagement.virtualOfficeTemplate.List.copyDialog.templateName')" style="margin-bottom: 0">
                                    <Input v-model="copySettings.templateName" show-word-limit :maxlength="50"/>
                                </FormItem>
                            </Form>
                            <div slot="footer">
                                <Button type="text" size="large" @click="copy_dialog=false">{{ $t('Button.cancel') }}</Button>
                                <Button type="primary" size="large" :loading="save_loading" @click="debounce(copyTemplate)">{{ $t('virtualOfficeManagement.virtualOfficeTemplate.List.copyDialog.copyBtn') }}</Button>
                            </div>
                        </Modal>
                        <Button
                                v-if="hasPermission('deleteTemplate')"
                                type="dashed"
                                size="large"
                                icon="md-trash"
                                @click.stop="remove(p.id,p.templateName)"
                        >{{ $t('Button.remove') }}</Button>
                    </div>
                </li>
            </ul>

            <Spin v-show="loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                    class="pager"
                    :total="pagination.total"
                    :current="pagination.page"
                    :page-size="pagination.pageSize"
                    @on-change="v=>pagination.page=v"
                    @on-page-size-change="v=>pagination.pageSize=v"
                    show-elevator
                    show-sizer
                    transfer
            />
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import api from "@/api/Api";
    import extend from "extend";
    import apimodel from "@/model/ApiModel";
    import helper from "@/assets/helper.js";
    import PrettyText from "@/components/PrettyText";
    import Preview from "@/components/VideoPreviewDialog";
    import PicturePreviewDialog from "@/components/PicturePreviewDialog";
    import PrettyImage from "@/components/PrettyImage";
    import logger from "@/assets/log";
    const log = logger("views:material:all");

    let { Const } = apimodel;

    export default {
        components: {
            PrettyText,
            Preview,
            PicturePreviewDialog,
            PrettyImage
        },
        mixins: [
            {
                methods: helper
            }
        ],
        data() {
            return {
                Const,
                loading: false,
                save_loading: false,
                copy_dialog: false,
                copySettings: {
                    id: 0,
                    templateName: ''
                },
                list: []
            };
        },
        computed: {
            filter: {
                get() {
                    return this.$store.state.views.virtualOfficeTemplate.all.filter;
                },
                set(v) {
                    this.$store.commit("views/virtualOfficeTemplate.all.filter", v);
                }
            },
            pagination: {
                get() {
                    return this.$store.state.views.virtualOfficeTemplate.all.pagination;
                },
                set(v) {
                    this.$store.commit("views/virtualOfficeTemplate.all.pagination", v);
                }
            },
            ...mapState({
                uploaderLoading: state =>
                    state.uploader.UploadServer.loadingStatus == "loading",
                uploaderReady: state =>
                    state.uploader.UploadServer.loadingStatus == "done",
                uploaderResult: state => state.uploader.newMaterialStatus
            }),
            dep(){
                return this.filter.selectType == 2
            }
        },
        watch: {
            'filter.depId'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.templateNameLike'() {
                this.pagination.page = 1;
                this.refresh();
            },
            'filter.userCode'() {
                this.pagination.page = 1;
                this.refresh();
            },
            "pagination.page"() {
                this.refresh();
            },
            "pagination.pageSize"() {
                this.refresh();
            },
            uploaderResult(val) {
                let item = val[val.length - 1];
                if (!item.status) {
                    this.pagination.page == 1 && this.refresh();
                } else {
                }
            }
        },
        methods: {
            addCopySettings(id, name){
                this.copy_dialog = true;
                this.copySettings.id = id;
                this.copySettings.templateName = name;
            },
            async copyTemplate(){
                if(this.hasPermission('复制云演播厅模板保存')){
                    this.save_loading = true;
                    try {
                        let ret = await api.call("virtualOffice/templateCopySave", this.copySettings);

                        this.$Notice.success({ title: this.$t('Message.copy.success') });
                        this.copy_dialog = false;
                        this.refresh();
                    } catch (e) {
                        this.$Notice.error({ title: this.$t('Message.copy.error'), desc: e.resultMsg });
                    }
                    setTimeout(()=>{
                        this.save_loading = false;
                    },2000);
                }else {
                    this.$Notice.error({ title: this.$t('Message.permission.error') });
                }
            },
            async remove(id, title) {
                if (!confirm(this.$t('Message.remove.confirm') + `(${title}) ?`)) return;

                this.loading = true;

                try {
                    let ret = await api.call("virtualOffice/templateDelete", {
                        id: id
                    });

                    this.$Notice.success({ title: this.$t('Message.remove.success') + `(${title})` });

                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.remove.error') + `(${title})`, desc: e.resultMsg });
                }
                this.loading = false;
            },
            async refresh() {
                this.loading = true;

                try {
                    let param = extend(true, {}, this.pagination, this.filter);
                    let ret = await api.call("virtualOffice/templateList", param);

                    this.list = ret.list;
                    this.pagination.total = ret.total;
                } catch (e) {}

                this.loading = false;
            }
        },
        mounted() {
            //如果是 Cordova app 此页作为首页，回到本页后清楚历史记录
            if (this.isCordova() && navigator.app && navigator.app.clearCache) {
                navigator.app.clearHistory();
            }
            this.refresh();
        },
        created() {},
        beforeDestroy() {

        }
    };
</script>

<style lang="less" scoped>
    @keyframes spin1 {
        from {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(180deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .box {
    }
    .header {
        & > * {
            margin-bottom: 10px;
            border-radius: 5px;
        }
        .toolbar {
            height: 32px;
            line-height: 32px;

            button {
                margin-right: 22px;
                vertical-align: middle;
            }

            .search {
                width: 200px;
            }
        }
    }
    .content {
        position: relative;
        border-radius: 5px;
        background: white;
        padding: 0 20px;

        .spin {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
        }
    }

    .filter{
        overflow:hidden;
        white-space: nowrap;
        position: relative;
    }
    .filter-expend{
        overflow: visible;
        white-space: normal;
        position: static;
        .filter-box li{
            margin:5px 5px;
        }
        .more-btn{
            position:relative
        }
    }

    .list {
        list-style: none;
        padding: 0 7px;
        border-radius: 5px;
        background: white;

        .item {
            border-bottom: 1px solid #e9e9e8;
            height: 120px;
            padding: 15px 0;
            white-space: nowrap;
            position: relative;
            overflow: hidden;
            & > * {
                /*height: 100%;*/
                display: inline-block;
                vertical-align: middle;
            }

            .title-tag {
                border-radius: 5px;
                font-size: 12px;
                background: #e3e3e3;
                padding: 2px;
            }
            .item-thumb {
                height: 90px;
                // 如果设置 line-height: 90px 内容会下移1px，原因不明
                line-height: 89px;
                width: 160px;
                border-radius: 5px;
                overflow: hidden;
                margin-right: 12px;
                position: relative;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    vertical-align: middle;
                    border: 0;
                }
                canvas {
                    width: 100%;
                    border: 0;
                    vertical-align: middle;
                }
                .view {
                    width: 160px;
                    height: 90px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                .view:hover {
                    cursor: pointer;
                    background: rgba(0, 0, 0, 0.3);
                }
                .view-icon {
                    visibility: hidden;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    margin: -12px 0 0 -12px;
                    color: #ffffff;
                    z-index: 1000;
                }
                .view:hover .view-icon {
                    visibility: visible;
                }
                .view:hover .play-btn {
                    visibility: visible;
                }
                .play-btn {
                    visibility: hidden;
                    width: 40px;
                    height: 40px;
                    font-size: 30px;
                    position: absolute;
                    cursor: pointer;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(255, 255, 255, 0.5);
                    box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px;
                    border-radius: 40px;
                    i {
                        width: 100%;
                        height: 100%;
                        line-height: 40px;
                        text-align: center;
                        vertical-align: top;
                        padding-left: 5px;
                    }
                }
                .play-btn:hover {
                    background: #fff;
                }
            }
            .item-info {
                & > .title {
                    font-size: 15px;
                    color: #666;
                    & > * {
                        vertical-align: middle;
                    }
                    a {
                        margin-left: 5px;
                    }
                }
                .list {
                    color: #989898;
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    line-height: 19px;

                    .title {
                        width: 60px;
                        display: inline-block;
                    }
                    .title:after {
                        content: ":";
                    }
                    .video-level-tag {
                        border-radius: 2px;
                        margin-right: 5px;
                        border-bottom: 1px dashed #e3e3e3;
                        cursor: pointer;
                    }
                    .video-level-tag:after {
                        content: "、";
                    }
                    .video-level-tag:last-child:after {
                        content: "";
                    }
                }
            }
            .item-op {
                position: absolute;
                right: 0;
                height: auto;
                width: 200px;
                background: white;
                text-align: right;
                white-space: normal;
                .delete_btn2 {
                    display: none;
                }
                .default_btn{
                    background-color: yellow;
                }
            }
        }
    }
    .pager {
        text-align: center;
        padding: 10px;
    }

    @media only screen and (max-width: 1440px) {
        .list .item .item-info > .title a {
            width: 80%;
        }
    }

    @media all and (orientation: portrait), all and (max-width: 1024px) {
        .list .item .item-op {
            background: transparent;
            .edit_btn {
                display: none;
            }
            .download_btn {
                display: none;
            }
            .delete_btn {
                display: none;
            }
            .delete_btn2 {
                display: inline-block;
            }
            bottom: 10px;
        }
        .list .item .item-thumb {
            width: 60px;
        }
        .content {
            padding: 0;
        }
    }
</style>